import { CheckCircleFilledIcon } from '../icons/CheckCircleFilledIcon';
import { LeadStatusIcon } from '../icons/LeadStatusIcon';

import type { StatusBadgeConfigMap } from '@/components/ui/status-badge';

export type XeroInvoiceState = 'generated' | 'not_generated';

const XERO_INVOICE_VIEW_URL = 'https://go.xero.com/AccountsReceivable/Edit.aspx?InvoiceID=';

// Xero status is not synced, so any stored invoice ID counts as generated.
export function xeroInvoiceState(xeroInvoiceId: string | null): XeroInvoiceState {
  return xeroInvoiceId ? 'generated' : 'not_generated';
}

export function xeroInvoiceUrl(xeroInvoiceId: string): string {
  return `${XERO_INVOICE_VIEW_URL}${xeroInvoiceId}`;
}

export const XERO_INVOICE_BADGE_CONFIG: StatusBadgeConfigMap<XeroInvoiceState> = {
  generated: {
    label: 'Generated',
    icon: <CheckCircleFilledIcon className="size-4 shrink-0 text-confirmed-green" aria-hidden="true" />,
    bgClassName: 'bg-[#e3fcef]',
    borderClassName: 'border-[#8cd9c3]',
    textClassName: 'text-confirmed-green',
  },
  not_generated: {
    label: 'Not generated',
    icon: <LeadStatusIcon className="shrink-0 text-turmeric-yellow" aria-hidden="true" />,
    bgClassName: 'bg-custard-yellow',
    borderClassName: 'border-butter-yellow',
    textClassName: 'text-turmeric-yellow',
  },
};
